import React from 'react'
import { useOutletContext } from 'react-router-dom'
import YoutubeCreditsView from '../pricing/YoutubeCreditsView'
import { usePageTitle } from '../../components/common/PageTitleContext'
import type { AppOutletContext } from '../../app/AppShell'

const YoutubeCreditsPage: React.FC = () => {
  const { me } = useOutletContext<AppOutletContext>()

  usePageTitle('YouTube credits')

  return <YoutubeCreditsView variant="app" me={me} isLoggedIn={true} />
}

export default YoutubeCreditsPage
